// @ts-ignore
import React from 'react';
import styled from '@emotion/styled';
import { Spring } from 'react-spring/renderprops.cjs';
import { isMobile } from 'react-device-detect';

const SlideContainer = styled.div`
    cursor: pointer;
    position: absolute;
    height: 100%;
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin: 50% 50%;
    img {
        object-fit: scale-down;
        display: block;
        max-height: 100%;
    }
`;

interface IProps {
    content: JSX.Element;
    // eslint-disable-next-line react/require-default-props
    onClick?: () => void;
    numberOfSideCards: number;
    index: number;
    animationConfig: object;
}

export default function NoaSlide({
    content, numberOfSideCards, index, animationConfig, onClick,
}: IProps) {
    // Offset radius: number of cards to display to the side

    // 0 for first card, -1 for first card to left, 1 for card to right, -2 for second card to left, 2 for second card to right, etc...
    const offsetFromCenter = index - numberOfSideCards;

    const HORIZONTAL_CENTER = 50;
    const exponentialIndent = Math.abs(offsetFromCenter) * offsetFromCenter; // Increase indent as cards extend to the sides
    const horizontalDistanceFromCenter = HORIZONTAL_CENTER - exponentialIndent + (offsetFromCenter / 8) * 100;

    const cardScale = 1 - Math.abs(offsetFromCenter / (numberOfSideCards + 1) / 1.5);

    const brightness = cardScale * cardScale * cardScale;

    // To reduce lag on mobile, only do brightness filter on desktop
    const filterDesktopOnly = isMobile
        ? {}
        : {
            filter: `brightness(${brightness})`,
        };

    return (
        <Spring
            to={{
                transform: `translateY(-50%) translateX(-50%) scale(${cardScale})`,
                left: `${horizontalDistanceFromCenter}%`,
                ...filterDesktopOnly,
            }}
            config={animationConfig}
        >
            {(style) => (
                <SlideContainer style={{ ...style, zIndex: Math.abs(Math.abs(offsetFromCenter) - 2) }} onClick={onClick}>
                    {content}
                </SlideContainer>
            )}
        </Spring>
    );
}
